export const Path = {
    Home: "/",
    Booking: {
        Home: "/booking",
        SelectFlight: "/booking/select",
        PaxInfo: "/booking/passenger",
        SpecialServices: "/booking/special-services",
        PrePayment: "/booking/preview",
        ManageBooking: "/booking/manage",
        Itinerary: "/booking/itinerary",
        ItineraryEn: "/booking/en-itinerary",
        Ticket: "/booking/ticket",
        ReservationStatus: "/booking/find",
        Cancelation: "/booking/cancel",
        Modification: "/booking/modify",
    },
    Payment: {
        Failed: "/payment/failed",
        Successed: "/payment/successed"
    },
    Profile: {
        Home: "/profile",
        History: "/profile/history",
        ExclusivePersonList: "/profile/passengers",
        Addresses: "/profile/addresses",
        Feedbacks: "/profile/feedbacks",
        PersonalInformation: "/profile/personal-info",
        ManageProfile: "/manage-profile",
    },
    Modify: {
        Home: "/modify",
        FlightSearch: "/modify/search",
        SelectFlight: "/modify/select",
        SpecialServices: "/modify/special-services",
        PrePayment: "/modify/preview",
    },
    Checkin: {
        Login: "/checkin",
        SelectPassenger: "/checkin/passenger",
        SelectSeat: "/checkin/seat",
        Itinerary: "/checkin/itinerary",
        BoardingPass: "/boarding-pass",
        TripTrack: "/trip-track",
    },
    FlightSurvey: {
        Start: "/flight-survey",
        Questionnaire: "/flight-survey/questionnaire",
        Feedback: "/flight-survey/feedback"
    },
    Feedback: {
        Home: "/feedback",
        Details: "/feedback/details",
        FeedbackItem: "/feedback/feedback-details"
    },
    Tourism: {
        Agenda: "/agenda",
        AgendaDetail: "/agenda",
        Attraction: "/attraction",
        AttractionDetail: "/attraction",
        Event: "/events",
        Itinerary: "/itinerary"
    },
    LostBaggage: "/luggage-inquiry",
    ContactUs: "/contact-us",
    Destinations: "/destinations",
    Login: "/login",
    Signout: "/signout",
    News: "/news-and-announcements",
    Magazine: "/magazine",
    KidsStory: "/kids-story",
    Fleet: "/fleet",
    FleetSeatMap: "/seat-map",
    SalesOffices: "/sales-offices",
    Laboratories: "/medical-laboratories",
    TravelConditions: "/travel-conditions",
    DomesticRoute: "/domestic-route",
    InternationalRoute: "/international-route",
    Survey: "/survey",
    PrivacyPolicy: "/privacy-policy",
    TermCondition: "/terms-and-conditions",
    FreeUpgrade: "/free-upgrade",
    CRM: "/crm",
    FAQ: "/faq"
}